const ShopRoutes = {
  getShopDetailById: 'getStoreDetail/',
  getTopSellers: 'getTopSellers',
  getUserDetail: 'getUserDetails',
};

export default ShopRoutes